import {ErrorMessage} from 'components/common/ErrorMessage'
import {Footer, Header} from 'components/system'
import {Button} from 'components/system/Button'
import {Modal} from 'components/system/Modal'
import {useGetProductQuery} from 'hooks/ventrata/useGetProductQuery'
import {useCurrency} from 'providers/EnvironmentProvider'
import {getProductDurationFrom} from '../utils/getProductDurationFrom'
import {Carousel} from './Carousel'
import {CostFrom} from './CostFrom'

type Props = {
  onCheckAvailability: () => void
  onClose: () => void
  productId: string
}

export const ProductCard = ({onCheckAvailability, productId, onClose}: Props) => {
  const currency = useCurrency()
  const getProductQuery = useGetProductQuery(productId)

  if (getProductQuery.error) {
    return <ErrorMessage error={getProductQuery.error} />
  }

  if (!getProductQuery.data) {
    return null
  }

  const product = getProductQuery.data
  const productDuartionFrom = getProductDurationFrom(product)

  return (
    <Modal className="w-full h-full d:!w-[1136px] d:h-[calc(100%-64px)] !rounded-none d:!rounded-2xl flex flex-col">
      <Header title="Tour details" onClose={onClose} />
      <div className="grow overflow-y-scroll px-4 py-6 d:px-8 d:py-6 ">
        <div className="text-[24px] d:text-[28px] font-bold">{product.title}</div>
        {product.subtitle && <div className="text-lg mt-2" dangerouslySetInnerHTML={{__html: product.subtitle}} />}
        <Carousel galleryImages={product.galleryImages || []} />
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-[110px_1fr] gap-y-2">
            <div className="text-text-secondary">Duration from</div>
            <div className="font-medium">{productDuartionFrom}</div>
          </div>
        </div>
        {product.description && (
          <div className="text-lg mt-2" dangerouslySetInnerHTML={{__html: product.description}} />
        )}
      </div>
      <Footer>
        <div className="flex justify-between w-full items-center">
          <CostFrom product={product} currency={currency} />
          <Button.Primary.Orange onClick={onCheckAvailability} autoExpanded className="!w-fit !d:w-auto">
            Check Availability
          </Button.Primary.Orange>
        </div>
      </Footer>
    </Modal>
  )
}
